import { Influencer, SocialAccount } from "types/influencer"
import InfluencerCardHeader from "./InfluencerCardHeader"
import { CampaignApplication } from "types/campaign/applications"
import InfluencerStats from "./InfluencerStats"
import { ACCOUNT_NOT_FOUND_MSG } from "constants/global"

interface InfluencerCardProps {
    name: string,
    language?: string
    gender?: string,
    location?: string,
    socialAccount?: SocialAccount,
    application: Pick<CampaignApplication, 'requirement_match' | 'requirement_match_details' | 'authenticity_score' | 'authenticity_score_details' | 'average_views'>
}
const InfluencerCard: React.FC<InfluencerCardProps> = ({ name, socialAccount, gender, location, application, language }) => {
    return (
        <div className="influencer-card">
            <InfluencerCardHeader 
                name={name}
                gender={gender}
                location={location}
                socialAccount={socialAccount}
                language={language}
                headerRightContent={
                    (
                        <div className="application-card-action d-flex flex-column justify-content-center gap-2">
                            <span className="application-action navigate-icon text-primary bg-primary-light"><i className="mdi mdi-arrow-top-right" /></span>
                        </div>
                    )
                }
            />
            {
                socialAccount ? (
                    <InfluencerStats
                        average_views={application.average_views}
                        engagement_color={socialAccount.engagement_rate_details.color}
                        engagement_score={socialAccount.engagement_score}
                        authenticity_color={application.authenticity_score_details.color}
                        authenticity_score={application.authenticity_score}
                        requirement_match_color={application.requirement_match_details.color}
                        requirement_match={application.requirement_match}
                        followers_count={socialAccount.followers_count}
                    />
                ) : (
                    <div className="account-not-available-card">
                        <span className="w-75">{ACCOUNT_NOT_FOUND_MSG}</span>
                    </div>
                )
            }
        </div>
    )
}

export default InfluencerCard